// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as OrderActions } from '../../duck';
import { actions as AlertActions } from '../../../alert/duck';
import Purchase from '../components/Purchase';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    localValues: state.localValues,
    localeState: state.locale,
    isFetchingOrder: state.order.isFetchingOrder,
    order: state.order.order,
    fetchOrderError: state.order.fetchOrderError,
    isProgressingOrder: state.order.purchase.registerPurchase.isPostingIdentity ||
      state.order.purchase.registerPurchase.isProgressing,
    progressError: state.order.purchase.registerPurchase.postIdentityError ||
      state.order.purchase.registerPurchase.progressError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...OrderActions,
    ...AlertActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Purchase);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/containers/PurchaseContainer.jsx